import { render } from "./SentimentCharts.vue?vue&type=template&id=0c52fdb6"
import script from "./SentimentCharts.vue?vue&type=script&lang=js"
export * from "./SentimentCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__